import React, { Fragment } from "react";
import { Field, FieldProps, Form, FormikProps } from "formik";
import classnames from "classnames";
import { WithTranslation, withTranslation } from "react-i18next";
import TextField from "@material-ui/core/TextField";
import { wire } from "react-hot-wire";

import { AddUserFormValues as FormValues } from "./Erase";
import Switch from "components/common/form/switch/Switch";

const AddUser = ({
  formikProps: { errors, touched },
  t
}: {
  formikProps: FormikProps<FormValues>;
} & WithTranslation) => (
  <Form className="d-flex flex-column h-100">
    <div className="d-flex flex-column h-100">
      <div
        className="flex-grow-1 py-4 px-5 overflow-auto"
        style={{ backgroundColor: "rgb(241, 243, 244)" }}
      >
        <Fragment>
          <section className="box rounded p-3 mb-2">
            <p className="box__description mb-1">
              {t("application.erase.field.confirmAppName")}
            </p>
            <section className="d-flex flex-column">
              <Field
                name="appName"
                render={({ field }: FieldProps<FormValues>) => (
                  <TextField
                    {...field}
                    autoFocus
                    inputProps={{
                      className: "px-2"
                    }}
                    className={classnames(" m-0", {
                      "is-valid": !errors.appName && touched.appName,
                      "is-invalid": errors.appName && touched.appName
                    })}
                    tabIndex={1}
                  />
                )}
              />
              {errors.appName && touched.appName && (
                <div className="d-flex invalid-feedback">
                  {t("application.erase.error.confirmAppName")}
                </div>
              )}
            </section>
          </section>
          <section className="box rounded p-3 mb-2">
            <p className="box__description mb-1">
              {t("application.erase.field.removeFromList")}{" "}
              <small>
                ({t("application.erase.field.removeFromListDescription")})
              </small>
            </p>
            <section className="d-flex flex-column">
              <Field name="removeFromList">
                {({ field, form }: FieldProps<FormValues>) => (
                  <Switch
                    value={field.value}
                    onChange={checked =>
                      form.setFieldValue(field.name, checked)
                    }
                  />
                )}
              </Field>
            </section>
          </section>
          <section className="box rounded p-3 mb-2">
            <p className="box__description mb-1">
              {t("application.erase.field.removeJobsAndDeployments")}
            </p>
            <section className="d-flex flex-column">
              <Field name="removeJobsAndDeployments">
                {({ field, form }: FieldProps<FormValues>) => (
                  <Switch
                    value={field.value}
                    onChange={checked =>
                      form.setFieldValue(field.name, checked)
                    }
                  />
                )}
              </Field>
            </section>
          </section>
        </Fragment>
      </div>
    </div>
  </Form>
);

export default wire(["siteService"], withTranslation()(AddUser));
